// A text input hands back "" when the user clears it, while the dialog state
// and the API both say null for "not set". The conversion lives here so the
// dialogs don't each carry their own copy of it.
const emptyToNull = (s: string | null | undefined): string | null =>
  s == null || s.trim() === "" ? null : s;

export default emptyToNull;
